<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.grape.list")}}</span>
    <div class="list-container">
      <AveineGrapeList :APIbaseURL="APIbaseURL" :adminMode="true"/>
    </div>
  </div>
</template>

<script>

import { AveineGrapeList } from 'aveine-grape';
export default {
  name: 'Index',
  data() {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  components: {
    AveineGrapeList
  }
}
</script>
